import React, { useEffect, useState } from "react";
import Bell from "./Bell";

const BellOverlay = () => {
  const [showBell, setShowBell] = useState(
    JSON.parse(localStorage.getItem("isBellAnimating")) || false
  );

  useEffect(() => {
    const handleBellChange = () => {
      setShowBell(JSON.parse(localStorage.getItem("isBellAnimating")) || false);
    };

    // Listen for the custom event
    window.addEventListener("bellAnimatingChanged", handleBellChange);

    return () => {
      window.removeEventListener("bellAnimatingChanged", handleBellChange);
    };
  }, []);

  if (!showBell) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 100,
        left: 0,
        width: "100%",
        zIndex: 2000,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Bell position="left" />
        <Bell position="right" />
      </div>
    </div>
  );
};

export default BellOverlay;
